import { makeStyles } from '@material-ui/core/styles';

export const useTicketDetailViewStyles = makeStyles(() => ({
  divider: {
    marginTop: 20,
    marginBottom: 5,
  },
}));

export const useButtonContainerStyles = makeStyles(() => ({
  title: {
    fontSize: 14,
    marginBottom: 33,
  },
  button: {
    marginBottom: 13,
  },
}));
